import { Injectable } from '@angular/core'
import { CollectionRepository } from '@engineering11/web-api-firebase'
import { Observable } from 'rxjs'
import { COLLECTIONS } from 'shared-lib'
import { IAssistantPendingAction } from '../models/assistant-pending-action.model'

/**
 * Live-listener store for the assistant pending-action doc (CAP-1/CAP-3). Backed by
 * `@engineering11/web-api-firebase` `CollectionRepository`; `getValueChanges` yields the doc and every
 * subsequent Firestore change, so the confirmation card appears, resolves, and withdraws in place with
 * no polling. Mirrors `assistant-conversation.repository.ts`.
 */
@Injectable({ providedIn: 'root' })
export class AssistantPendingActionRepository extends CollectionRepository<IAssistantPendingAction> {
  // BACKEND CONTRACT (assumption) — see ../BACKEND-CONTRACT.md
  protected COLLECTION = COLLECTIONS.ASSISTANT_PENDING_ACTION

  /** Live pending-action document (keyed by conversation id). Emits the current doc and every Firestore update. */
  livePendingAction(id: string): Observable<IAssistantPendingAction | undefined> {
    return this.getValueChanges(id)
  }
}
